import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n';
import ListLoadingPlaceholder from '@/components/ListLoadingPlaceholder.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FarmsLoadingPlaceholder',
  setup(__props) {

const { t } = useI18n();
const captions = [
  {
    caption: t('farming.apr.caption'),
    tooltip: t('farming.apr.tooltip'),
  },
  {
    caption: t('farming.totalStake.caption'),
    tooltip: t('farming.totalStake.tooltip'),
  },
  {
    caption: t('farming.youEarned.caption'),
    tooltip: t('farming.youEarned.tooltip'),
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ListLoadingPlaceholder, {
      captions: captions,
      count: "3"
    })
  ]))
}
}

})